import request from '@/utils/request'
import type * as common from '@/typings/common'
interface DiscussListPmParams {
  project_id: number
  comment_type?: number
  comment_to_id?: number
  pm_id: number
}
// 获取评论列表
export async function getCommentList(params: DiscussListPmParams) {
  return request('/api/v2/project/discuss_list_by_pm', {
    method: 'GET',
    data: params
  })
}
interface DiscussListParams {
  project_id: number
  comment_type?: number
  comment_to_id?: number
}
// 获取评论列表
export async function getDiscussList(params: DiscussListParams) {
  return request('/api/v2/project/discuss_list', {
    method: 'GET',
    data: params
  })
}

interface CreateDiscussRequest {
  discuss: common.CommentRequest
}
// 写评论
export async function createDiscuss(params: CreateDiscussRequest) {
  return request('/api/v2/project/discuss_create', {
    method: 'POST',
    data: params
  })
}

interface UpdateDiscussRequest {
  discuss: common.CommentRequest
}
// 编辑评论
export async function updateDiscuss(params: UpdateDiscussRequest) {
  return request('/api/v2/project/discuss_update', {
    method: 'POST',
    data: params
  })
}

interface DiscussIdParams {
  discuss_id: number
}
// 删除评论
export async function deleteDiscuss(params: DiscussIdParams) {
  return request('/api/v2/project/discuss_delete', {
    method: 'POST',
    data: params
  })
}

// 点赞评论
export async function likeDiscuss(params: DiscussIdParams) {
  return request('/api/v2/project/discuss_like', {
    method: 'POST',
    data: params
  })
}

// 项目评论-取消点赞
export async function unlikeDiscuss(params: DiscussIdParams) {
  return request('/api/v2/project/discuss_unlike', {
    method: 'POST',
    data: params
  })
}
